export default __webpack_public_path__ + "static/media/Rubik-Light.b1f0f1d8.woff2";